import React from 'react';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../../root/tcsm-model';
import { PersonSearchProps } from '../../models/arc-epi-props';

interface Props {
    searchResultsRef: React.MutableRefObject<any>;
}

export function PersonSearchToast(props: Props) {
    const { searchResultsRef } = props;
    const personSearchProps = useSelector<TcsmStates, PersonSearchProps>(state => state.epiProps.personSearchSettingsState.epiContent);

    let message = personSearchProps?.matchesToastMessage;
    const anchorText = personSearchProps?.matchesToastAnchorText;
    const anchorIndex = message.indexOf('{anchor}');
    message = message.replace('{anchor}', '');

    return (
        <>
            <h5>{personSearchProps.matchesToastTitle}</h5>
            <p>
                {message.substring(0, anchorIndex === -1 ? message.length - 1 : anchorIndex)}
                <button className='alert-link-button paragraph' type='button' onClick={() => searchResultsRef.current.scrollIntoView({ behavior: 'smooth' })}>{anchorText}</button>
                {anchorIndex !== -1 ? message.substring(anchorIndex) : ''}
            </p>
        </>
    );
}